var React = require('react');

function ArrowRightGrey (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.59884 32L0 28.0006L13.7994 16L0 3.99937L4.59884 0L23 15.9975L4.59884 32Z","fill":"#585E65"}));
}

ArrowRightGrey.defaultProps = {"width":"23","height":"32","viewBox":"0 0 23 32","fill":"none"};

module.exports = ArrowRightGrey;

ArrowRightGrey.default = ArrowRightGrey;
